import * as React from "react";
import styled from "../../../styled/index";
import { shadeAlternate } from "../../../styled/helpers";
import { CS } from "../../../styles/index";
const ClickOutComponent = require("react-onclickout");
export const Wrapper = styled("div") `
  position: relative;
`;
export const ChildContent = styled("div") `
  cursor: pointer;
`;
export const Dropdown = styled("div") `
  position: absolute;
  display: ${({ active }) => active ? "block" : "none"};
  top: calc(100% + 4px);
  height: auto;
  min-width: 100px;
  width: 100%;
  border-radius: 5px;
  background: ${({ theme }) => theme.box.background};
  color: ${({ theme }) => theme.box.text};
  ${CS.shadow.heavy.one};
  z-index: 2;
`;
export const Content = styled("div") `
  display: flex;
  flex-direction: column;
  padding: 10px 10px;
`;
export const Item = styled("div") `
  cursor: pointer;
  padding: 10px 10px;
  border-radius: 5px;
  &:hover {
    background: ${({ theme }) => shadeAlternate(0.06, theme.box.background)};
  }
`;
export class DropDownList extends React.Component {
    clickOutActive = false;
    constructor(props) {
        super(props);
        this.state = {
            active: false,
        };
    }
    componentDidUpdate() {
        setTimeout(() => {
            this.clickOutActive = this.state.active;
        }, 100);
    }
    setActive = (active) => {
        this.setState({ active });
    };
    onClickOut = () => {
        if (this.state.active && this.clickOutActive) {
            this.setActive(false);
        }
    };
    onSelect = (selected) => {
        this.setActive(false);
        this.props.onSelect(selected);
    };
    render() {
        if (!this.state)
            return;
        const { active } = this.state;
        const { options, children } = this.props;
        return (React.createElement(Wrapper, null,
            React.createElement(ChildContent, { onClick: () => this.setActive(!active) }, children),
            React.createElement(ClickOutComponent, { onClickOut: this.onClickOut },
                React.createElement(Dropdown, { active: active },
                    React.createElement(Content, null, options.map((o, i) => (React.createElement(Item, { key: i, onClick: () => this.onSelect(o) }, o.label))))))));
    }
}
//# sourceMappingURL=index.js.map